import { Component, EventEmitter, HostListener, Output, ViewChild, ElementRef, ContentChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { WafFormHelper } from '@tcm-modules/tcm-core.module';

@Component({
    selector: 'advanced-search',
    templateUrl: 'advanced-search.component.html',
    styleUrls: ['advanced-search.component.scss'],
    standalone: false
})
export class AdvancedSearchComponent {

    @Output() submit = new EventEmitter();
    @Output() clear = new EventEmitter();

    @ContentChild(NgForm) private nestedNgForm: NgForm;
    @ContentChild(NgForm, { read: ElementRef }) private nestedNgFormElementRef: ElementRef;

    @HostListener('keydown.enter')
    onMouseEnter() {
        this.submit.emit(null);
    }

    onSubmit() {

        if(this.nestedNgForm && !this.nestedNgForm.valid){
            WafFormHelper.invalidateForm(this.nestedNgForm, this.nestedNgFormElementRef.nativeElement, true);
            return;
        }

        this.submit.emit(null);
    }

    onClear() {
        this.clear.emit(null);
    }
}
